import { useQuery } from "@tanstack/react-query";

import { get } from "api";

const useDunningMembership = () => {
  const { data: userMemberships } = useQuery({
    queryKey: ["/platform-user-memberships/status"],
    queryFn: () => get("/platform-user-memberships/status"),
  });

  const dunningMembership = userMemberships?.find(
    ({ canceled, dunningStage }) => !canceled && dunningStage > 0
  );

  return {
    dunningMembership: {
      status: !!dunningMembership,
      id: dunningMembership?.id || "",
    },
  };
};

export default useDunningMembership;
